
export default function AboutSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              About Marketing Ads
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              We are a specialized e-commerce performance marketing agency dedicated to helping brands achieve exponential growth through data-driven strategies and creative excellence.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Our mission is to transform your online presence into a powerful revenue-generating machine. We combine cutting-edge technology with proven marketing methodologies to deliver measurable results that matter to your bottom line.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">500+</div>
                <div className="text-gray-600">Successful Campaigns</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">$50M+</div>
                <div className="text-gray-600">Revenue Generated</div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/a87b20229cf58ccfce4af6e0912ec624.jpg"
              alt="Marketing Ads team working on campaigns"
              className="rounded-lg shadow-lg object-cover w-full h-96"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
